const folderList = [
  {id: 120, name: 'All', alias: 'all', icon: 'group'},
  {id: 121, name: 'Starred', alias: 'starred', icon: 'star'},
  {id: 122, name: 'Priority', alias: 'priority', icon: 'mail'},
  {id: 123, name: 'Scheduled', alias: 'scheduled', icon: 'schedule'},
  {id: 124, name: 'Today', alias: 'today', icon: 'today'},
  {id: 125, name: 'Completed', alias: 'completed', icon: 'done'},
  {id: 126, name: 'Deleted', alias: 'deleted', icon: 'delete'},
];
export default folderList;
